import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { constant } from './constants';
import translation from './translation';
import { encode as base64_encode } from 'base-64';
import history from '../../../../../commons/history';
import StyledTable from '../../../../../commons/styles/table';
import themeSettings from '../../../../../commons/styles/themeSettings.json';
import {
  Input,
  Popconfirm,
  Tooltip,
  Divider,
  Space,
  Card,
  Pagination,
  Select,
  Empty,
  DatePicker,
  Form,
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  PlusOutlined,
  SolutionOutlined
} from '@ant-design/icons';
import {
  CardTitle,
  CardFooterActions,
  StyledNoBorderSelect
} from '../CSS/style';

const ListView = (props) => {
  const [state, setState] = useState({
    userList: props.userList || [],
    columns: props.columns || [],
    dataSource: props.dataSource || [],
    listData: props.dataSource || [],
    config: props.config || {},
    viewType: props.config && props.config.defaultViewType ? props.config.defaultViewType : 'card',
    userProfile: props.userProfile || [],
    translationCache: props.translationCache || [],
    searchField: '',
    current: 1,
    pageSize: 10,
    filterKey: null,
    EquipmentKey: ''
  });

  useEffect(() => {
    if (
      state.userProfile !== props.userProfile ||
      dataSource !== props.dataSource ||
      state.translationCache !== props.translationCache ||
      config !== props.config
    ) {
      setState(prevState => ({
        ...prevState,
        userProfile: props.userProfile,
        listData: props.dataSource,
        config: props.config
      }));
    }
  }, [props.userProfile, props.dataSource, props.translationCache, props.config]);

  const filterByValue = (value) => {
    let { dataSource } = props;
    let { filterKey } = state;
    return (
      dataSource &&
      Array.isArray(dataSource) &&
      dataSource.filter((data) => {
        return (
          data[filterKey] &&
          data[filterKey].toString().toLowerCase().includes(value.toString().toLowerCase())
        );
      })
    );
  };

  const onSearch = (value) => {
    let listData = filterByValue(value);
    setState(prevState => ({ ...prevState, listData }));
  };

  const add3Dots = (text, limit) => {
    let dots = '...';
    if (text && text.length > limit) {
      text = text.substring(0, limit) + dots;
    }
    return text;
  };

  const onPaginationChange = (current, pageSize) => {
    setState(prevState => ({ ...prevState, current, pageSize }));
  };

  const onViewTypeChange = (viewType) => {
    setState(prevState => ({ ...prevState, viewType }));
  };

  const _deleteRecord = async (id) => {
    props.delete(id);
  };

  const _editRecord = async (id) => {
    let { config } = state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(id)}` });
  };

  const _editRecordDetails = async (id) => {
    let { config } = props;
    history.push({ pathname: `${config.edit.redirectDetailsURL}/${base64_encode(id)}` });
  };

  const { current, pageSize, viewType, listData } = state;
  let { columns, dataSource, config, selection } = props;
  let {
    viewTypes,
    filterType,
    attributeList,
    attributeListTitle,
    firstTitle,
    secondTitle,
    thirdTitle,
    actions,
    edit,
    deletee
  } = config;

  const IconText = ({ icon, text }) => (
    <Space>
      {React.createElement(icon)}
      {text}
    </Space>
  );

  const LabelValue = ({ labelText, valueText }) => (
    <Space>
      {labelText}
      {valueText}
    </Space>
  );

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <StyledNoBorderSelect>
          {filterType === 'ByAttributeValue' && viewType === 'card' ? (
            <div>
              <Select
                showSearch
                placeholder={translation(props.translationCache, constant.selectAttribute)}
                allowClear
                value={state.filterKey}
                style={{
                  background: '#1a3652',
                  borderRight: 'none',
                  borderTop: 'none',
                  borderLeft: 'none',
                  width: '40%'
                }}
                onChange={(e) => {
                  // setState({ filterKey: e });
                  setState(prevState => ({
                    ...prevState,
                    filterKey: e
                  }));
                }}
              >
                {attributeList && Array.isArray(attributeList)
                  ? attributeList.map((attribute, index) => {
                    return (
                      <Select.Option key={attribute}>
                        {attributeListTitle && attributeListTitle[index]
                          ? attributeListTitle[index]
                          : attribute}
                      </Select.Option>
                    );
                  })
                  : null}
              </Select>
              <Input
                type="text"
                style={{
                  background: '#1a3652',
                  borderRight: 'none',
                  borderTop: 'none',
                  color: 'white',
                  borderLeft: 'none',
                  width: '60%'
                }}
                id="searchText"
                value={state.searchField}
                onChange={(e) => {
                  setState(prevState => ({
                    ...prevState,
                    searchField: e.target.value
                  }));
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearch(state.searchField);
                  }
                }}
                placeholder={translation(props.translationCache, constant.search)}
              />
              {/* <Button onClick={()=>this.props.reset()}>reset</Button> */}
            </div>
          ) : null}
        </StyledNoBorderSelect>

        <div style={{ marginTop: '9px' }}>
          {viewTypes && viewTypes.includes('add') ? (
            <Tooltip
              placement="top"
              key="Add"
              title={translation(props.translationCache, constant.Add)}
            >
              <PlusOutlined
                onClick={() =>
                  props.navigate({
                    pathname: `${config.edit.redirectURL}/${base64_encode('new')}`
                  })
                }
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : (
            <div></div>
          )}
          <Divider type="vertical" />
          {viewTypes && viewTypes.includes('card') ? (
            <Tooltip
              placement="top"
              key="GridView"
              title={translation(props.translationCache, constant.GridView)}
            >
              <AppstoreOutlined
                onClick={() => onViewTypeChange('card')}
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : null}

          {viewTypes && viewTypes.includes('table') ? (
            <Tooltip
              placement="top"
              key="ListView"
              title={translation(props.translationCache, constant.ListView)}
            >
              <UnorderedListOutlined
                onClick={() => onViewTypeChange('table')}
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : null}
        </div>
      </div>
      {selection && selection.widget && selection.widget === 'date-picker' ? (
        <div style={{ display: 'flex', justifyContent: 'right', margin: '10px 0px' }}>
          <Form theme={themeSettings}>
            <Form.Item label="Select Date">
              <DatePicker
                placeholder="Select Date"
                defaultValue={moment()}
                format={'YYYY-MM-DD'}
                onChange={(e) => props._getDataSource(moment(e).format('YYYY-MM-DD'))}
              />
            </Form.Item>
          </Form>
        </div>
      ) : null}

      <div style={{ marginTop: '10px' }}>
        {viewType === 'card' ? (
          <div>
            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {listData
                  .filter(
                    (e, index) =>
                      index >= pageSize * current - pageSize && index < pageSize * current
                  )
                  .map((list) => {
                    return (
                      <Card
                        key={list.TaskName}
                        style={{ width: '410px', padding: '5px', margin: '5px' }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <CardTitle theme={themeSettings}>
                            {add3Dots(list[firstTitle], 35)}
                          </CardTitle>

                          <div style={{ margin: '0px 0px 7px 0px' }}>
                            {config.TitleView === true ? (
                              <LabelValue
                                labelText={
                                  config.InspectionView === true
                                    ? 'Description :'
                                    : `${config.secondTitle}:`
                                }
                                valueText={list[secondTitle]}
                                key="list-vertical-star-o"
                              />
                            ) : (
                              <IconText
                                icon={UserOutlined}
                                text={list[secondTitle]}
                                key="list-vertical-star-o"
                              />
                            )}
                          </div>
                          {config && config.thirdTitle ? (
                            config && config.TitleView === true ? (
                              <div style={{ margin: '0px 0px 7px 0px' }}>
                                <LabelValue
                                  labelText={`${config.thirdTitle}:`}
                                  valueText={list[thirdTitle]}
                                  key="list-vertical-like-o"
                                />
                              </div>
                            ) : (
                              <div style={{ margin: '0px 0px 7px 0px' }}>
                                <IconText
                                  icon={CalendarOutlined}
                                  text={moment(list[thirdTitle])
                                    .utc()
                                    .local()
                                    .format('YYYY-MM-DD HH:mm:ss')}
                                  key="list-vertical-like-o"
                                />
                              </div>
                            )
                          ) : null}
                        </div>
                        <Divider
                          style={{
                            borderTop: '1px solid #000',
                            height: '0px',
                            margin: '15px 0px'
                          }}
                        />

                        <CardFooterActions>
                          {actions && actions.includes('edit') ? (
                            <Tooltip
                              placement="top"
                              key="Edit"
                              title={translation(props.translationCache, constant.Edit)}
                            >
                              <EditOutlined
                                style={{
                                  color: themeSettings.list.card.icon.color,
                                  marginRight: '8px'
                                }}
                                onClick={() => _editRecord(list[edit.byAttribute])}
                              />
                            </Tooltip>
                          ) : config.InspectionView === true ? (
                            <Tooltip
                              placement="right"
                              title={translation(
                                props.translationCache,
                                constant.ViewInspection
                              )}
                            >
                              <EyeOutlined
                                onClick={() => _editRecord(list[edit.byAttribute])}
                              />
                            </Tooltip>
                          ) : null}
                          <Divider type="vertical" />
                          {actions && actions.includes('delete') ? (
                            <Popconfirm
                              key="1"
                              title="Are you sure you want to delete the record ?"
                              icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                              onConfirm={() => _deleteRecord(list[deletee.byAttribute])}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Tooltip
                                placement="top"
                                key="Delete"
                                title={translation(
                                  props.translationCache,
                                  constant.Delete
                                )}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: themeSettings.list.card.icon.color,
                                    marginRight: '8px'
                                  }}
                                />
                              </Tooltip>
                            </Popconfirm>
                          ) : null}
                          <Divider type="vertical" />
                          {actions && actions.includes('details') ? (
                            <Tooltip
                              placement="top"
                              key="Edit"
                              title={translation(props.translationCache, constant.Edit)}
                            >
                              <SolutionOutlined
                                style={{
                                  color: themeSettings.list.card.icon.color,
                                  marginRight: '8px'
                                }}
                                onClick={() => _editRecordDetails(list[edit.byAttribute])}
                              />
                            </Tooltip>
                          ) : null}
                        </CardFooterActions>
                      </Card>
                    );
                  })}
              </div>
            ) : (
              <Empty style={{ color: 'white' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}

            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexDirection: 'row', margin: '14px' }}>
                <Pagination
                  current={current}
                  onChange={onPaginationChange}
                  total={listData.length}
                  pageSize={10}
                />
              </div>
            ) : null}
          </div>
        ) : (
          <StyledTable size="small"
            dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
            columns={columns}
            scroll={{ x: 1300 }}
          />
        )}
      </div>
    </>
  );
};

export default connect(/* mapStateToProps, mapDispatchToProps */)(ListView);
